import { NgModule } from '@angular/core';
import { HasRightDirective } from 'app/shared/directives/hasright/hasright.directive';

@NgModule({
  declarations: [HasRightDirective],
  exports: [HasRightDirective],
})
export class HasrightModule {}
